import * as React from 'react';
import UploadModal from './uploadModal';

type ViewMenuRender = (setArgs: React.Dispatch<React.SetStateAction<{
    asDraft: boolean;
    forceToView: boolean;
    viewLocation?: string;
}>>, setShowModal: React.Dispatch<React.SetStateAction<boolean>>) => React.ReactElement<any>;

export const ViewMenu: React.FC<{ close: () => void, render: ViewMenuRender }> = ({ close, render }) => {
    const [showModal, setShowModal] = React.useState(false)
    const [args, setArgs] = React.useState({ asDraft: true, forceToView: false })

    return showModal ? (
        <UploadModal
            publishArgs={args}
            close={close}
        />
    )
        : (render(setArgs, setShowModal))
}